export default {
  activityTitle: state => state.ux.activityTitle,
  activityType: state => state.ux.activityType,
  reminderType: state => state.ux.reminderType,
  isPreviewMode: state => state.ux.isPreviewMode
}